import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=64d4267d&scoped=true&"
import script from "./CitySelect.vue?vue&type=script&lang=js&"
export * from "./CitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4267d",
  null
  
)

export default component.exports